import { Log } from '@lightningjs/sdk';
import { AdultType, CardType, SortBy, SortDir } from '../../api/models/Shared.types';
import { CmsRibbon } from '../../components/cms/CmsRibbon';
import { CardDataSource } from './CardDataSource';
import { CardSizeInfo } from './CardSizeInfo';
import { recordingToRibbon2Asset } from '../recording/RecordingConversions';
import { LLDataSource } from './LLDataSource';
import { Backend } from '../../api/Backend';
import { Recording } from '../../api/user/RecordingApi.types';
import { ChannelModel } from '../../api/EpgApi.types';

export class RecordingRibbonDataSource extends LLDataSource {
  private recordings: Recording[];
  private properties: string[];
  private channels: ChannelModel[];
  private allowAdult: AdultType;
  private sortBy: SortBy;
  private sortDir: SortDir;
  private cardType: CardType;
  public sizeInfo: CardSizeInfo;
  private title: undefined;
  constructor(
    backend: Backend,
    recordings: Recording[],
    properties: string[],
    channels: ChannelModel[],
    allowedAdultMode = AdultType.Any,
    sortBy = SortBy.episode,
    sortDir = SortDir.Asc,
    cardType = CardType.Landscape
  ) {
    super(backend);
    this.recordings = recordings;
    this.properties = properties;
    this.channels = channels;
    this.allowAdult = allowedAdultMode;
    this.sortBy = sortBy;
    this.sortDir = sortDir;
    this.cardType = cardType;

    this.hasNextPage = true;
    this.sizeInfo = new CardSizeInfo();

    this.title = undefined; //RecordingRibbons never have a title (tabs button)
  }

  set initialSizeInfo(szi: CardSizeInfo) {
    this.sizeInfo = szi;
  }

  _fetchPage() {
    return Promise.all(this.recordings.map(rec => recordingToRibbon2Asset(this.backend, rec)))
      .then(result => {
        this.hasNextPage = false;
        this.sizeInfo.updateWithContainer(
          {
            type: CardType.Landscape,
            nextPage: false,
            items: result,
          },
          this.properties
        );
        this.items = result.map(
          item => new CardDataSource(this.backend, item, this.sizeInfo, this.properties, this.channels)
        );
        return this.items;
      })
      .catch(err => {
        Log.error(`Error fetching recordingRibbon ${this}: ${err}`);
        return [];
      });
  }

  totalHeight() {
    return this.sizeInfo.height;
  }

  override componentDescription() {
    return {
      focusable: true,
      type: CmsRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
